import React from 'react';
import cn from 'classnames';
import styles from './Label.module.scss';

interface OwnProps {
  children: React.ReactNode;
}

interface Props extends OwnProps {}

const Label = ({ children }: Props) => (
  <div
    className={cn(styles.label, {
      [styles.info]: true,
    })}
  >
    {children}
  </div>
);

export default Label;
